export default __webpack_public_path__ + "static/media/legguards_of_the_vanguard.4c086740.jpg";